const replaceZentaiToBasename = (originalLabelName, basename) => {
  const correctBasenames = [
    "進学者全体",
    "大学進学者全体",
    "短大進学者全体",
    "短期大学進学者全体",
    "専門学校進学者全体",
    "専門学校進学者全体",
  ]
  if (correctBasenames.filter(correctBasename => originalLabelName.match(new RegExp(correctBasename))).length === 0) {
    return originalLabelName.replace('全体', basename)
  } else {
    return originalLabelName
  }
};

export default replaceZentaiToBasename;